import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { addDays, formatKoreanDate, getTodayKey, getWeekDays } from '../utils/dateUtils';

const SchedulerHeader = ({ selectedDate, onDateChange }) => {
  const weekDays = getWeekDays(selectedDate);
  const todayKey = getTodayKey();
  const selectedWeekday = weekDays.find((date) => date.key === selectedDate)?.weekday;
  const selectedWeekendClass = selectedWeekday === '토'
    ? 'is-saturday'
    : selectedWeekday === '일'
      ? 'is-sunday'
      : '';

  return (
    <section className="scheduler-calendar-card">
      <header className="scheduler-date-nav">
        <button type="button" onClick={() => onDateChange(addDays(selectedDate, -1))} aria-label="이전 날짜">
          <FiChevronLeft aria-hidden="true" />
        </button>
        <button
          type="button"
          className={`scheduler-date-nav__today ${selectedWeekendClass}`.trim()}
          onClick={() => onDateChange(todayKey)}
        >
          {formatKoreanDate(selectedDate)}
        </button>
        <button type="button" onClick={() => onDateChange(addDays(selectedDate, 1))} aria-label="다음 날짜">
          <FiChevronRight aria-hidden="true" />
        </button>
      </header>

      <div className="scheduler-week" aria-label="주간 날짜 선택">
        {weekDays.map((date) => (
          <button
            type="button"
            className={`${date.key === selectedDate ? 'is-selected' : ''} ${date.key === todayKey ? 'is-today' : ''} ${date.weekday === '토' ? 'is-saturday' : ''} ${date.weekday === '일' ? 'is-sunday' : ''}`.trim()}
            onClick={() => onDateChange(date.key)}
            key={date.key}
          >
            <span>{date.weekday}</span>
            <strong>{date.day}</strong>
          </button>
        ))}
      </div>
    </section>
  );
};

export default SchedulerHeader;
